
const AlternateLanguagePageLink = ({
  href,
  lang_attr,
  text,
  id
}) => (
  <a id={id} className='alternate-lang-page-link' href={href} lang={lang_attr}>{text}</a>
)

export default AlternateLanguagePageLink